import React from "react";
import MobileBoardHeader from "./MobileBoardHeader";
import BoardToolbar from "./BoardToolbar";
import { usePlannerContext } from "./PlannerContext";


export default function MobileBoard({
  mobileBoardRole = "",
  visibleRoleKeys = [],
  roleOptions,
  setMobileBoardRole = () => {},
  selectedDayMs,
  cardStyle,
  BOARD_BLOCKS = [],
  dailyByBlockRole = {},
  openOverflow = () => {},
  PlannerShiftCard,
  LifecycleBoxes,
  RoleVisibilityStrip,
  SelectionActionBar,
}) {
  const activeRole = mobileBoardRole || visibleRoleKeys[0];
  const activeLabel = roleOptions?.map?.get(activeRole) || activeRole;

  const {
    selectedShiftId,
    selectedShiftIds,
    toggleShiftSelection,
    setSelectedShiftId,
    workersByUid,
    shortWorkerLabel,
    now,
  } = usePlannerContext();

  return <div className="schedule-board">
    <BoardToolbar RoleVisibilityStrip={RoleVisibilityStrip} SelectionActionBar={SelectionActionBar} />
    <MobileBoardHeader selectedDayMs={selectedDayMs} />
    <div style={{padding:8}}>
      <div className="schedule-mobile-role-picker" aria-label="Schedule role">
        {visibleRoleKeys.map(rk => <button key={rk} type="button" aria-pressed={rk === activeRole}
          onClick={() => setMobileBoardRole(rk)}>{String(roleOptions?.map?.get(rk) || rk).replace(/_/g,' ')}</button>)}
      </div>
      {!visibleRoleKeys.length ? <p className="smallMeta">No visible roles. Use Roles → Show all.</p> : BOARD_BLOCKS.map(blk => {
        const list = dailyByBlockRole?.[blk.key]?.[activeRole] || [];
        return <section key={blk.key} className="schedule-mobile-block" aria-label={blk.label+' · '+activeLabel}>
          <h3 style={{fontSize:13,margin:'0 0 8px',fontWeight:650}}>{blk.label} · {String(activeLabel).replace(/_/g,' ')}</h3>
          {!list.length ? <div className="smallMeta">No shifts in this block.</div> : <div style={{display:'grid',gap:6}}>
            {list.slice(0,4).map(s => <PlannerShiftCard key={s.id} shift={s}
              compactHeight={list.length >= 5 ? 44 : list.length === 4 ? 52 : list.length === 3 ? 66 : 92}
              now={now} selectedShiftId={selectedShiftId} selectedShiftIds={selectedShiftIds}
              toggleShiftSelection={toggleShiftSelection} setSelectedShiftId={setSelectedShiftId}
              workersByUid={workersByUid} shortWorkerLabel={shortWorkerLabel} LifecycleBoxes={LifecycleBoxes} />)}
            {list.length > 4 && <button type="button" className="schedule-overflow" onClick={() => openOverflow(blk.label+' • '+activeLabel,list)}>+{list.length-4} more</button>}
          </div>}
        </section>;
      })}
    </div>
  </div>;
}
